// extracted by mini-css-extract-plugin
export var resizer = "_ft-0";